import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { PaymentHistoryComponent } from './user-dashboard/payment-history/payment-history.component';
import { ProfileComponent } from './user-dashboard/profile/profile.component';
import { SocialMediaAccountsComponent } from './user-dashboard/social-media-accounts/social-media-accounts.component';
import { PlansComponent } from './user-dashboard/plans/plans.component';
import { MoreToolsComponent } from './components/more-tools/more-tools.component';
import { UserHomeComponent } from './user-dashboard/user-home/user-home.component';
import { QuestionaryComponent } from './components/questionary/questionary.component';
import { BusinessInfoComponent } from './user-dashboard/business-info/business-info.component';
import { EventsComponent } from './user-dashboard/events/events.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { EditBusinessinfoComponent } from './user-dashboard/edit-businessinfo/edit-businessinfo.component';
import { ManageBusinessComponent } from './user-dashboard/manage-business/manage-business.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { PaymentstatusComponent } from './user-dashboard/paymentstatus/paymentstatus.component';
import { ManagerDashboardComponent } from './manager-dashboard/manager-dashboard.component';
import { ManagerLoginComponent } from './manager-dashboard/manager-login/manager-login.component';
import { ManagerRegistrationComponent } from './manager-dashboard/manager-registration/manager-registration.component';
import { ClientListComponent } from './manager-dashboard/client-list/client-list.component';
import { RequestListComponent } from './user-dashboard/request-list/request-list.component';
import { ProfilePageComponent } from './manager-dashboard/profile/profile-page.component';
import { ClientBusinessesComponent } from './manager-dashboard/client-businesses/client-businesses.component';
import { PromocodeComponent } from './admin-dashboard/promocode/promocode.component';
import { ManagerListComponent } from './admin-dashboard/manager-list/manager-list.component';
import { UserListComponent } from './admin-dashboard/user-list/user-list.component';
import { TransactionDetailsComponent } from './admin-dashboard/transaction-details/transaction-details.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { CreatePostComponent } from './manager-dashboard/create-post/create-post.component';
import { AuthGuard } from './auth.guard';
import { VoucherComponent } from './manager-dashboard/voucher/voucher.component';
import { AdsManagerComponent } from './user-dashboard/ads-manager/ads-manager.component';
import { AIComponent } from './user-dashboard/ai/ai.component';
import { AnalyticsComponent } from './user-dashboard/analytics/analytics.component';
import { DigitalMarketingComponent } from './components/digital-marketing/digital-marketing.component';
import { WebsiteDevolpmentComponent } from './components/website-devolpment/website-devolpment.component';
import { GraphicDesignComponent } from './components/graphic-design/graphic-design.component';
import { SeoComponent } from './components/seo/seo.component';
import { UIUXComponent } from './components/uiux/uiux.component';
import { VideoEditingComponent } from './components/video-editing/video-editing.component';

const routes: Routes = [
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  { path: 'Home', component: HomeComponent },
  { path: 'AboutUs', component: AboutusComponent },
  { path: 'Tools', component: MoreToolsComponent },
  { path: 'TermsAndConditions', component: TermsAndConditionsComponent },
  { path: 'PrivacyPolicy', component: PrivacyPolicyComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'ForgotPassword', component: ForgotPasswordComponent },
  { path: 'SignUp', component: RegisterComponent },
  { path: 'ContactUs', component: ContactUsComponent },
  { path: 'ManagerLogin', component: ManagerLoginComponent },
  { path: 'ManagerRegistration', component: ManagerRegistrationComponent },
  { path: 'digital-marketing', component: DigitalMarketingComponent },
  { path: 'website-development', component: WebsiteDevolpmentComponent },
  { path: 'graphic-editing', component: GraphicDesignComponent },
  { path: 'seo', component: SeoComponent },
  { path: 'UI-UX', component: UIUXComponent },
  { path: 'video-editing', component: VideoEditingComponent },

  
  // Protected Routes
  {
    path: 'Dashboard',
    component: UserDashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'Home', pathMatch: 'full' },
      { path: 'PaymentHistory', component: PaymentHistoryComponent },
      { path: 'Home', component: EventsComponent },
      { path: 'Profile', component: ProfileComponent },
      { path: 'SocialMediaAccounts', component: SocialMediaAccountsComponent },
      { path: 'Plans', component: PlansComponent },
      { path: 'BusinessInfo', component: BusinessInfoComponent },
      { path: 'Questionary', component: QuestionaryComponent },
      { path: 'EditBusinessInfo', component: EditBusinessinfoComponent },
      { path: 'ManageBusiness', component: ManageBusinessComponent },
      { path: 'PaymentStatus', component: PaymentstatusComponent },
      { path: 'AdsManager', component: AdsManagerComponent },
      { path: 'AI', component: AIComponent },
      { path: 'Analytics', component: AnalyticsComponent },
      { path: 'RequestList', component: RequestListComponent }
    ]
  },
  {
    path: 'ManagerDashboard',
    component: ManagerDashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'ClientList', pathMatch: 'full' },
      { path: 'ClientList', component: ClientListComponent },
      { path: 'ProfilePage', component: ProfilePageComponent },
      { path: 'ClientBusinesses', component: ClientBusinessesComponent },
      { path: 'CreatePost', component: CreatePostComponent },
      { path: 'Voucher', component: VoucherComponent }
    ]
  },
  {
    path: 'AdminDashboard',
    component: AdminDashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'Promocode', pathMatch: 'full' },
      { path: 'Promocode', component: PromocodeComponent },
      { path: 'ManagerList', component: ManagerListComponent },
      { path: 'UserList', component: UserListComponent },
      { path: 'TransactionDetails', component: TransactionDetailsComponent }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes ,{scrollPositionRestoration:'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
